import type {
  Conversation,
  ConversationThreadReadResponse,
} from "@rulebase/core/api";
import { queryOptions } from "@tanstack/react-query";
import { rulebaseApi2Request } from "../lib/rulebase-api2-client/client";

export function getConversationQueryOptions(conversationId: string) {
  return queryOptions({
    queryKey: ["conversations", conversationId],
    queryFn: () =>
      rulebaseApi2Request<{ data: Conversation }>(
        `/conversations/${encodeURIComponent(conversationId)}`,
      ),
  });
}

/**
 * Linked-activity thread, served by api2. `data` is null when the conversation
 * has no thread yet.
 */
export function getConversationThreadQueryOptions(conversationId: string) {
  return queryOptions({
    queryKey: ["conversations", conversationId, "thread"],
    queryFn: () =>
      rulebaseApi2Request<ConversationThreadReadResponse>(
        `/conversations/${conversationId}/thread`,
      ),
  });
}
